import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/exchange-transactions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getRateAmount = (Options = {}) => {
  return httpClient
    .get('/api/exchange-transactions/get-rate-amounts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/exchange-transactions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/exchange-transactions/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/exchange-transactions/${data.exc_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const customer = (Option = {}) => {
  return httpClient
    .get(
      '/api/customer-profiles?page=-1&fields[customer_profiles]=customer_id,customer_name,is_default,contact_no1'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const employee = (Option = {}) => {
  return httpClient
    .get(
      '/api/employee-profiles?page=-1&fields[employee_profiles]=employee_id,name_kh,name_en'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const currency = (Option = {}) => {
  return httpClient
    .get(
      '/api/currencies?page=-1&fields[currencies]=currency_id,currency_code,currency_name_en,currency_sign'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  customer,
  employee,
  currency,
  getRateAmount
}
